/**
 * Sneakzmarket — Lieferzeit & Abholung vor Ort
 * -----------------------------------------------
 * Fetcht Lagerbestandsdaten von api.sneakzmarket.ch und zeigt
 * dem Kunden das voraussichtliche Lieferdatum (Wochentag + Datum) an,
 * das sich beim Variantenwechsel automatisch aktualisiert.
 *
 * Kompatibel mit Broadcast Theme v8 (nutzt das 'change'-Event
 * auf dem Varianten-Input statt MutationObserver).
 *
 * Voraussetzungen im Theme:
 *  - snippets/delivery-info.liquid  →  rendert .delivery-date / .au-delivery-text / .pickup-info
 *  - estimate_delivery-Block im Produkt-Template aktiviert
 *  - assets/custom.css  →  Styles für .delivery-date, .au-delivery-text, .pickup-info usw.
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Standort-IDs (Shopify Location GIDs)
  // ---------------------------------------------------------------------------
  var LOCATIONS = {
    mainWarehouse:      'gid://shopify/Location/89028493622',  // Hauptlager
    secondaryWarehouse: 'gid://shopify/Location/80919855414',  // Neustadt
    onDelivery:         'gid://shopify/Location/97298350390',  // On Delivery
    chrisSports:        'gid://shopify/Location/98312814902',  // ChrisSports
    catrade:            'gid://shopify/Location/105896804727', // Catrade
    lvr:                'gid://shopify/Location/106692903287', // LVR
    end:                'gid://shopify/Location/106843373943', // END
    montanaSport:       'gid://shopify/Location/107720933751', // Montanasport
    goldenSneakers:     'gid://shopify/Location/109786399095', // Golden Sneakers
    stockX:             'gid://shopify/Location/110634729847', // StockX
    merz:               'gid://shopify/Location/114855313783', // Merz Saucony
    returnStack:        'gid://shopify/Location/115789201783', // Return-Stack Hauptlager
    fwrd:               'gid://shopify/Location/115851297143', // FWRD
    turum:              'gid://shopify/Location/115851329911', // Turum
    footshop:           'gid://shopify/Location/115891732855'  // Footshop (2026-10-07)
  };

  // Bestellschluss-Zeiten je Standort (Format HH:MM)
  var CUTOFF = {
    main:         '18:30',
    returnStack:  '18:30',
    secondary:    '18:00',
    chrisSports:  '15:00',
    catrade:      '15:00',
    montanaSport: '15:00',
    merz:         '15:00'
  };

  // ---------------------------------------------------------------------------
  // Liefertage je Standort — hier anpassen
  //
  // Zahl:    Transit-/Zustelltage ab dem Versandtag (für Standorte mit Cutoff).
  //          Der Versandtag selbst wird über den Cutoff bestimmt: Bestellung
  //          nach Cutoff, am Wochenende oder an einem Feiertag → Versand erst am
  //          nächsten Werktag. Ab dem Versandtag zählen die Zustelltage inkl.
  //          Samstag.
  // min/max: Spanne für Standorte ohne Cutoff (wird als "bis [Datum]" angezeigt,
  //          wenn min != max).
  //
  // Versand:    nur Mo–Fr (isDispatchDay).
  // Zustellung: Mo–Sa (isDeliveryDay) — Samstag neu; So + Feiertage zählen nie.
  // ---------------------------------------------------------------------------
  var DELIVERY_DAYS = {
    main:        1,
    returnStack: 1,
    secondary:   1,
    onDelivery:  { min: 3, max: 6 },
    chrisSports: 2,
    catrade:     2,
    montanaSport:2,
    merz:        2,
    lvr:         { min: 4, max: 5 },  // LVR
    fwrd:        { min: 4, max: 5 },  // FWRD (gleich wie LVR)
    end:         { min: 4, max: 5 },  // END
    goldenSneakers: { min: 4, max: 5 }, // Golden Sneakers
    turum:       { min: 4, max: 5 },  // Turum (gleich wie Golden Sneakers)
    // Footshop (Testbestellung 2026-10: Mo bestellt -> Mo in einer Woche bei
    // uns -> Di beim Kunden, plus 1-2 Werktage Puffer)
    footshop:    { min: 6, max: 8 },
    stockX:      { min: 4, max: 10 }   // StockX
  };

  // Varianten-IDs von Produkten, die immer als sofort verfügbar gelten
  var GIFT_CARD_VARIANT_IDS = ['gid://shopify/ProductVariant/47588065640758'];

  // ---------------------------------------------------------------------------
  // Feiertage — Daten im Format "DD.MM.YYYY" eintragen.
  // Fällt ein Feiertag in die Lieferfrist, verschiebt sich das Lieferdatum
  // automatisch nach hinten (1 Feiertag = +1 Tag, 2 aufeinanderfolgende = +2
  // Tage usw.). Wochenenden müssen hier NICHT eingetragen werden, die werden
  // separat behandelt.
  // ---------------------------------------------------------------------------
  var HOLIDAYS = [
    '14.05.2026',
    '25.05.2026',
    '01.08.2026',
    '25.12.2026',
    '26.12.2026',
    '01.01.2027',
    '02.01.2027',
    '26.03.2027',
    '29.03.2027',
    '01.05.2027',
    '06.05.2027',
    '17.05.2027',
    '01.08.2027',
    '25.12.2027',
    '26.12.2027'
  ];

  // Gecachte Inventardaten (werden einmalig pro Seitenload gefetcht)
  var inventoryData = {};

  // ---------------------------------------------------------------------------
  // Mehrsprachigkeit
  // Die Satz-Templates + die aktive Sprache kommen aus data-Attributen auf
  // .delivery-date (server-seitig via delivery-info.liquid gerendert). Datum
  // wird per Intl.DateTimeFormat(i18n.locale) lokalisiert. Die Defaults hier
  // sind nur ein Fallback, falls das Element/die Attribute fehlen.
  // ---------------------------------------------------------------------------
  var i18n = {
    locale:    'de',
    estimated: 'Voraussichtlich geliefert %DATE%',
    range:     'Voraussichtlich geliefert zwischen %START% und %END%',
    available: 'Sofort verfügbar'
  };

  function loadI18n() {
    var el = document.querySelector('.delivery-date');
    if (!el) return;
    i18n = {
      locale:    el.dataset.locale    || i18n.locale,
      estimated: el.dataset.tEstimated || i18n.estimated,
      range:     el.dataset.tRange     || i18n.range,
      available: el.dataset.tAvailable || i18n.available
    };
  }

  // ---------------------------------------------------------------------------
  // DOM-Hilfsfunktionen
  // ---------------------------------------------------------------------------
  function getProductId() {
    var el = document.querySelector('product-info[data-product-id]');
    return el ? el.getAttribute('data-product-id') : null;
  }

  function getCurrentVariantId() {
    var el = document.querySelector('product-form input[name="id"]');
    return el ? el.value : null;
  }

  function getDeliveryElements() {
    return {
      span:   document.querySelector('.au-delivery-text'),
      div:    document.querySelector('.delivery-date'),
      pickup: document.querySelector('.pickup-info')
    };
  }

  // ---------------------------------------------------------------------------
  // Datum-Helfer
  // ---------------------------------------------------------------------------
  function getTime() {
    var now = new Date();
    return now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');
  }

  // Feiertage als ISO-Strings ("YYYY-MM-DD") vorberechnen für O(1)-Lookup
  var HOLIDAY_SET = new Set(HOLIDAYS.map(function (d) {
    var parts = d.split('.');
    return parts[2] + '-' + parts[1] + '-' + parts[0];
  }));

  function isHoliday(date) {
    var iso = date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
    return HOLIDAY_SET.has(iso);
  }

  // Versandtag: das Lager versendet nur Mo–Fr (keine Feiertage).
  function isDispatchDay(date) {
    var dow = date.getDay();
    return dow !== 0 && dow !== 6 && !isHoliday(date);
  }

  // Zustelltag: der Kurier stellt Mo–Sa zu (Samstag neu!), nie sonn-/feiertags.
  function isDeliveryDay(date) {
    return date.getDay() !== 0 && !isHoliday(date);
  }

  /**
   * Addiert n Zustelltage (Mo–Sa, ohne So/Feiertage) ab dem tatsächlichen
   * Versandtag. Ist das Startdatum kein Versandtag (Sa/So/Feiertag oder nach
   * Cutoff bereits auf morgen vorverschoben), wird zuerst auf den nächsten
   * Versandtag (Mo–Fr) gesprungen — das ist der Tag, an dem das Paket rausgeht.
   * Danach zählen die Zustelltage inkl. Samstag.
   */
  function addDeliveryDays(date, n) {
    var result = new Date(date);
    while (!isDispatchDay(result)) {
      result.setDate(result.getDate() + 1);
    }
    var added = 0;
    while (added < n) {
      result.setDate(result.getDate() + 1);
      if (!isDeliveryDay(result)) continue;
      added++;
    }
    return result;
  }

  /**
   * Formatiert ein Datum lokalisiert als "Wochentag, Tag. Monat" (DE) bzw. das
   * sprachübliche Äquivalent (EN "Friday, July 3", FR "vendredi 3 juillet" …).
   * Die Sprache stammt aus i18n.locale (siehe loadI18n).
   */
  function formatDate(date) {
    return new Intl.DateTimeFormat(i18n.locale, {
      weekday: 'long',
      day:     'numeric',
      month:   'long'
    }).format(date);
  }

  /**
   * Berechnet das Lieferdatum aus Cutoff und Transit-Tagen.
   * Versandtag = heute, sofern heute ein Versandtag (Mo–Fr) und die Bestellung
   * vor Cutoff liegt; sonst der nächste Versandtag (nach Cutoff, am Wochenende
   * oder Feiertag → Versand am nächsten Werktag). Ab dem Versandtag werden dann
   * `transit` Zustelltage (inkl. Samstag) addiert.
   */
  function deliveryMessage(time, cutoff, transit) {
    var start = new Date();
    // Nach Cutoff an einem Versandtag → heute geht nichts mehr raus, ab morgen
    // suchen. Wochenende/Feiertag ist ohnehin kein Versandtag → addDeliveryDays
    // springt selbst auf den nächsten Werktag.
    if (isDispatchDay(start) && time >= cutoff) {
      start.setDate(start.getDate() + 1);
    }
    return i18n.estimated.replace('%DATE%', formatDate(addDeliveryDays(start, transit)));
  }

  /**
   * Berechnet eine Datumsrange.
   * Gibt den übersetzten "delivery_estimated_range"-Satz zurück
   * (min == max → einzelnes "delivery_estimated" statt Range).
   */
  function deliveryRangeMessage(days) {
    var now = new Date();
    if (days.min === days.max) {
      return i18n.estimated.replace('%DATE%', formatDate(addDeliveryDays(now, days.min)));
    }
    return i18n.range
      .replace('%START%', formatDate(addDeliveryDays(now, days.min)))
      .replace('%END%', formatDate(addDeliveryDays(now, days.max)));
  }

  // ---------------------------------------------------------------------------
  // Kernlogik: Lieferzeit für eine Variante bestimmen
  // ---------------------------------------------------------------------------
  function updateDeliveryDisplay(variantGid) {
    var elems = getDeliveryElements();
    if (!elems.span || !elems.div) return;

    // Geschenkgutschein: immer sofort verfügbar
    var variants = inventoryData.data.product.variants.edges;
    var isGiftCard = variants.some(function (v) {
      return GIFT_CARD_VARIANT_IDS.indexOf(v.node.id) !== -1;
    });
    if (isGiftCard) {
      setDisplay(elems, i18n.available, 'available-now');
      if (elems.pickup) elems.pickup.style.display = 'none';
      return;
    }

    var variant = variants.find(function (v) { return v.node.id === variantGid; });
    if (!variant) return;

    var levels = variant.node.inventoryItem.inventoryLevels.nodes;
    function stockAt(locationId) {
      var level = levels.find(function (l) { return l.location.id === locationId; });
      return level && level.quantities[0].quantity > 0;
    }

    // Abholung anzeigen wenn Ware im Haupt- oder Nebenlager (inkl. Return-Stack)
    if (elems.pickup) {
      var hasLocalStock = stockAt(LOCATIONS.secondaryWarehouse);
      elems.pickup.style.display = hasLocalStock ? 'flex' : 'none';
    }

    var time    = getTime();
    var message = null;
    var cssClass;

    if (stockAt(LOCATIONS.mainWarehouse)) {
      message  = deliveryMessage(time, CUTOFF.main, DELIVERY_DAYS.main);
      cssClass = 'available-now';
    } else if (stockAt(LOCATIONS.returnStack)) {
      message  = deliveryMessage(time, CUTOFF.returnStack, DELIVERY_DAYS.returnStack);
      cssClass = 'available-now';
    } else if (stockAt(LOCATIONS.secondaryWarehouse)) {
      message  = deliveryMessage(time, CUTOFF.secondary, DELIVERY_DAYS.secondary);
      cssClass = 'available-now';
    } else if (stockAt(LOCATIONS.onDelivery)) {
      message  = deliveryRangeMessage(DELIVERY_DAYS.onDelivery);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.chrisSports)) {
      message  = deliveryMessage(time, CUTOFF.chrisSports, DELIVERY_DAYS.chrisSports);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.catrade)) {
      message  = deliveryMessage(time, CUTOFF.catrade, DELIVERY_DAYS.catrade);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.montanaSport)) {
      message  = deliveryMessage(time, CUTOFF.montanaSport, DELIVERY_DAYS.montanaSport);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.merz)) {
      message  = deliveryMessage(time, CUTOFF.merz, DELIVERY_DAYS.merz);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.lvr)) {
      message  = deliveryRangeMessage(DELIVERY_DAYS.lvr);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.fwrd)) {
      message  = deliveryRangeMessage(DELIVERY_DAYS.fwrd);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.end)) {
      message  = deliveryRangeMessage(DELIVERY_DAYS.end);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.goldenSneakers)) {
      message  = deliveryRangeMessage(DELIVERY_DAYS.goldenSneakers);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.turum)) {
      message  = deliveryRangeMessage(DELIVERY_DAYS.turum);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.footshop)) {
      message  = deliveryRangeMessage(DELIVERY_DAYS.footshop);
      cssClass = 'longer-delivery';
    } else if (stockAt(LOCATIONS.stockX)) {
      message  = deliveryRangeMessage(DELIVERY_DAYS.stockX);
      cssClass = 'longer-delivery';
    }

    if (message === null) {
      setDisplay(elems, '', 'not-available');
    } else {
      setDisplay(elems, message, cssClass);
    }
  }

  function setDisplay(elems, text, cssClass) {
    elems.span.textContent = text;
    elems.div.classList.remove('not-available', 'longer-delivery', 'available-now');
    elems.div.classList.add(cssClass);
  }

  // ---------------------------------------------------------------------------
  // API-Fetch
  // ---------------------------------------------------------------------------
  function onFetchError() {
    var el = document.querySelector('.delivery-date');
    if (el) el.remove();
    var pickup = document.querySelector('.pickup-info');
    if (pickup) pickup.remove();
  }

  function fetchInventory(productId) {
    var body = new FormData();
    body.append('product_id', productId);

    fetch('https://api.sneakzmarket.ch/index.php', { method: 'POST', body: body })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        inventoryData = json;
        var variantId = getCurrentVariantId();
        if (variantId) {
          updateDeliveryDisplay('gid://shopify/ProductVariant/' + variantId);
        }
      })
      .catch(onFetchError);
  }

  // ---------------------------------------------------------------------------
  // Initialisierung
  // ---------------------------------------------------------------------------
  function init() {
    var productId = getProductId();
    if (!productId) return;

    loadI18n();
    fetchInventory(productId);

    // Variante gewechselt → Broadcast v8 feuert 'change' auf product-form input[name="id"]
    document.addEventListener('change', function (e) {
      if (!e.target.matches('product-form input[name="id"]')) return;
      if (!inventoryData.data) return;
      updateDeliveryDisplay('gid://shopify/ProductVariant/' + e.target.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
